import React from 'react';
import { ArrowLeft } from 'lucide-react';

/**
 * Coque des pages de détail du module inter-sites.
 *
 * La convention de navigation est le drill-in : « pas de modals pour afficher
 * les détails, utiliser des pages dédiées. Les modals restent réservés aux
 * actions — saisir, choisir, confirmer. »
 *
 * Le dossier d'un transfert s'ouvrait dans une fenêtre empilée au-dessus de sa
 * liste. Consulter n'est pas agir : on ne demande rien à la personne, on lui
 * montre. Une fenêtre modale l'oblige pourtant à fermer avant de reprendre son
 * travail, et cantonne le dossier à la largeur qu'on lui a laissée.
 *
 * La liste cède donc la place au détail, avec un retour explicite. La lecture
 * gagne toute la largeur de l'écran, et l'historique reste là où on l'a laissé.
 */
const PageDetailInterSite = ({
  titre,
  sousTitre,
  retourLibelle = 'Retour',
  onRetour,
  icone: Icone = null,
  actions = null,
  children
}) => (
  <div className="space-y-4">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="flex items-start gap-3 min-w-0">
        <button
          type="button"
          onClick={onRetour}
          className="mt-0.5 h-9 px-3 rounded-lg border border-gray-200 text-xs font-semibold text-gray-600 inline-flex items-center gap-2 hover:bg-gray-50 transition-colors flex-shrink-0"
        >
          <ArrowLeft size={14} />
          {retourLibelle}
        </button>

        <div className="flex items-start gap-3 min-w-0">
          {Icone && (
            <span className="w-10 h-10 rounded-lg bg-[#246990] text-white flex items-center justify-center flex-shrink-0">
              <Icone size={18} />
            </span>
          )}
          <div className="min-w-0">
            <h2 className="text-lg font-semibold text-gray-900 truncate">{titre}</h2>
            {sousTitre && <p className="text-sm text-gray-500 mt-0.5 truncate">{sousTitre}</p>}
          </div>
        </div>
      </div>

      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>

    {children}
  </div>
);

export default PageDetailInterSite;
